import { CallIcon, DownloadIcon, EmailIcon, GemIcon, Typography } from "@cpj-ai/panel-npm-package";
import { Button } from "@heroui/react";
import { OrganizationInformationAndCredentials } from "./hooks/useOrganizationInformationFormData";

interface ICredentialsInformationProps {
  data: OrganizationInformationAndCredentials;
}

const CredentialsInformation = ({ data }: ICredentialsInformationProps) => {
  if (data?.dnstxtrecordmethod) {
    return (
      <div>
        <div className="p-4 rounded-xl border-1 border-zinc-200 mb-6">
          <Typography variant="small">Domain TXT Record</Typography>
          <Typography className="text-xs text-zinc-500 mt-2">
            In this method, Company should authenticate using company's domain and according to the mentioned method
          </Typography>
        </div>
        <div className="flex gap-10">
          <div className="flex gap-2 items-center">
            <GemIcon className="w-6 h-6" />
            <Typography>TXT code :</Typography>
          </div>
          <Typography className="tracking-[5px] uppercase text-gray-600">bQMR3VDaFOTTMAXednrwk_di</Typography>
        </div>
      </div>
    );
  } else if (data?.uploadfiletowebsitemethod) {
    return (
      <div>
        <div className="p-4 rounded-xl border-1 border-zinc-200 mb-6">
          <Typography variant="small">Uploading File to the Website Hosting Root</Typography>
          <Typography className="text-xs text-zinc-500 mt-2">
            In this method, Company should authenticate using company's domain and according to the mentioned method
          </Typography>
        </div>
        <div className="flex gap-10">
          <div className="flex gap-2 items-center">
            <GemIcon className="w-6 h-6" />
            <Typography>Website Hosting Root file.zip</Typography>
          </div>
          <div className="flex gap-4 items-center ms-40">
            <Typography variant="small" className="text-zinc-500">
              size : 743 kb
            </Typography>
            <Button
              variant="bordered"
              color="primary"
              className="rounded-xl border-2"
              startContent={<DownloadIcon className="w-6 h-6 fill-primary-500" />}
            >
              Download
            </Button>
          </div>
        </div>
      </div>
    );
  } else if (data?.uploadcompanycertificatemethod) {
    return (
      <div>
        <div className="p-4 rounded-xl border-1 border-zinc-200 mb-6">
          <Typography variant="small">Upload Company Certificate</Typography>
          <Typography className="text-xs text-zinc-500 mt-2">
            In this method, Company should authenticate using company's domain and according to the mentioned method
          </Typography>
        </div>

        <div className="w-64 h-48 bg-zinc-200 mb-4 rounded-xl" />
        <Button
          variant="bordered"
          color="primary"
          className="rounded-xl border-2"
          startContent={<DownloadIcon className="w-6 h-6 fill-primary-500" />}
        >
          Download
        </Button>
      </div>
    );
  } else if (data?.communicateorganizationmethod) {
    return (
      <div>
        <div className="p-4 rounded-xl border-1 border-zinc-200 mb-6">
          <Typography variant="small">Mail and call Organization Administrator</Typography>
          <Typography className="text-xs text-zinc-500 mt-2">
            In this method, Company should authenticate using company's domain and according to the mentioned method
          </Typography>
        </div>

        <div className="flex gap-6">
          <div className="flex gap-1 items-center">
            <div className="flex gap-1 items-center">
              <EmailIcon className="w-6 h-6" />
              <Typography variant="small">Mail:</Typography>
            </div>
            <a href={`mailto:${data?.communicateorganizationmethod?.email}`} className="text-sm text-zinc-500">
              {data?.communicateorganizationmethod?.email}
            </a>
          </div>

          <div className="flex gap-1 items-center">
            <div className="flex gap-1 items-center">
              <CallIcon className="w-6 h-6" />
              <Typography variant="small">Phone:</Typography>
            </div>
            <a href={`tel:${data?.communicateorganizationmethod?.phonenumber}`} className="text-sm text-zinc-500">
              {data?.communicateorganizationmethod?.phonenumber}
            </a>
          </div>
        </div>
      </div>
    );
  } else {
    return <p className="text-zinc-500 text-center text-xl py-5">No method selected</p>;
  }
};

export default CredentialsInformation;
